

import Recognition from '@/components/Recognition';
import InstagramGalleryAbout from '@/components/gallery/InstagramGalleryAbout';
export default {
  // layout: 'about',
  components: {
    Recognition,
    InstagramGalleryAbout
  },
  head() {
    return {
      title: "About GOA APP - Who we are and what we do?",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Founded in 2016, Meet the Goa App Team - Introducing the diverse and talented individuals who make up the heartbeat of Goa App. From developers to creatives, our team is fueled by a shared passion for travel.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'Goa, Goa Tourism, Goa travel, Attractions in Goa, Adventure in Goa, Goa experiences, Book activities in Goa, Goa sightseeing, Goa adventure app, Travel planning Goa, Rent vehicles in Goa, Local transportation Goa'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: "About GOA APP - Who we are and what we do?"
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Founded in 2016, Meet the Goa App Team - Introducing the diverse and talented individuals who make up the heartbeat of Goa App. From developers to creatives, our team is fueled by a shared passion for travel.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: "About GOA APP - Who we are and what we do?"
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Founded in 2016, Meet the Goa App Team - Introducing the diverse and talented individuals who make up the heartbeat of Goa App. From developers to creatives, our team is fueled by a shared passion for travel.'
      }
      ],
      script: [{
        src: '/js/timeline.js',
        body: true
      },

      ],
    }
  },


}
